import React from 'react';

// Digital HIG Components
// @ts-ignore
import DHBox from "@digital-hig/mui/Box";
// @ts-ignore
import DHTypography from "@digital-hig/mui/Typography";

// Icons
import SuccessIcon from './SuccessIcon';

interface PopupHeaderProps {
  title: string;
}

export const PopupHeader: React.FC<PopupHeaderProps> = ({ title }) => {
  return (
    <DHBox
      sx={{
        flex: '0 0 auto',
        marginBottom: 2
      }}
    >
      {/* Box container with tick icon and text */}
      <DHBox
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          textAlign: 'left',
          padding: 2
        }}
      >
        {/* Success Icon */}
        <DHBox
          sx={{
            marginBottom: 2
          }}
        >
          <SuccessIcon width={49} height={48} />
        </DHBox>
        
        {/* Title */}
        <DHTypography
          id="popup-title"
          variant="headline-small"
          component="h2"
          sx={{
            fontFamily: 'Artifakt Element',
            fontWeight: 700,
            fontSize: '18px',
            lineHeight: '125%',
            color: 'ink-on-background'
          }}
        >
          {title}
        </DHTypography>
      </DHBox>
    </DHBox>
  );
};

